import React from 'react'
import Classes from '../Dashboard.module.css'
import { useNavigate } from 'react-router-dom'

export default function TrialStrip() {
    const navigateTo = useNavigate();

    return (
        <>
            <div className={Classes.trialStrip} >
                <h5> Make your profile live by setting your availability. </h5>
                <button onClick={() => navigateTo('/availability')} > <h5>Set Availability</h5> </button>
            </div>
        </>
    )
}
